<template>
    <el-collapse
        v-model="activeNames"
        class="entities-collapse"
        :class="hasConflicts?'show-conflict-entity-title': ''"
    >
        <el-collapse-item
            :title="entity.name"
            :name="entity.name"
        >
            <div
                v-if="filteredFeedResources.length > 0"
            >
                <gcmcn-filters
                    ref="gcmcn-filters"
                    :filter-values="[
                        searchFilter,
                    ]"
                    @reset-filters="resetFilters"
                >
                    <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
                </gcmcn-filters>
                <feed-carousel
                    v-for="feedResource in filteredFeedResources"
                    :key="feedResource.uid"
                    :feed-resource="feedResource"
                    :feeds="feeds"
                    :active-names="activeNames"
                    :name="entity.name"
                    :filtered-events="filteredEvents"
                    @has-conflicts="setHasConflicts"
                ></feed-carousel>
            </div>
            <div
                v-else
                class="no-item"
            >
                No Feed Resources
            </div>
        </el-collapse-item>
    </el-collapse>
</template>

<script>
import FeedCarousel from './feed-carousel.vue';
import { SearchFilter, GcmcnFilters } from 'gcmcn-common';
export default {

    name: 'feed-resource-overview',

    components:{
        FeedCarousel,
        SearchFilter,
        GcmcnFilters
    },

    props:{
        entity:{
            type: Object,
            required: true
        },
        feedResources:{
            type: Array,
            required: true
        },
        feeds:{
            type: Array,
            required: true
        },
        filteredEvents:{
            type: Array,
            required: true
        },
    },

    data () {
        return {
            activeNames: [],
            conflictData: null,
            searchFilter: ''
        };
    },

    computed:{
        filteredFeedResources(){
            let filteredFeedResourcesByEntity = this.feedResources.filter((resource) =>
                resource.scopes.entity_uid === this.entity.uid);
            let sortedFeedResources = filteredFeedResourcesByEntity.sort((a, b) => a.display_name.localeCompare(b.display_name));
            if(this.searchFilter){
                let searchFilter = this.searchFilter.toLowerCase();
                return sortedFeedResources.filter(
                    (resource) => resource.name.toLowerCase().includes(searchFilter)
                );
            }
            return sortedFeedResources;
        },
        hasConflicts(){
            if(this.conflictData){
                const values = Object.values(this.conflictData);
                return values.includes(true);
            }
            return false;
        }
    },
    methods:{
        setHasConflicts(data){
            if(!this.conflictData){
                this.$set(this, 'conflictData', {});
            }
            this.$set(this.conflictData, [data.resourceName], data.hasConflict);
        },
        resetFilters (){
            this.$store.commit('CLEAR_ALL_FILTERS');
        },
    }
};
</script>

<style lang="scss">
.el-collapse.entities-collapse{
    width: 100%;
    border: none;
    background: linear-gradient(90deg, rgba(34, 34, 34, 0.3) 0%, rgba(17, 17, 17, 0.3) 100%);
    margin-bottom: 1rem;
    .el-collapse-item{
        background: linear-gradient(90deg, rgba(34, 34, 34, 0.3) 0%, rgba(17, 17, 17, 0.3) 100%);
        border-radius: 5px;
        border: none;
        &__header{
            padding: 2rem;
            border-radius: 5px;
            color: #BBBBBB;
            font-size: 20px;
            border: none;
            background: linear-gradient(90deg, rgba(34, 34, 34, 0.3) 0%, rgba(17, 17, 17, 0.3) 100%);
            text-transform: uppercase;
        }
        &__wrap{
            background: linear-gradient(90deg, rgba(34, 34, 34, 0.3) 0%, rgba(17, 17, 17, 0.3) 100%);
            padding: 2rem;
            border: none;
        }
    }
    .gcmcn-filter-container{
        margin: 0;
    }
}
.el-collapse.show-conflict-entity-title{
    .el-collapse-item{
        &__header{
            color: #f35858;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/page/FeedResourcesOverview/feed-resource-overview.vue